import { LocaleStrings } from '../keys';

const ar: LocaleStrings = {
  nav_home: 'Home',
  nav_search_label: 'Search',
  nav_profile: 'Profile',
  header_btn_create: 'Create Story',
  header_user_default: 'User',
  header_sign_out: 'Sign Out',
  search_placeholder: 'Searchâ€¦',
  theme_toggle_light: 'Switch to Light Mode',
  theme_toggle_dark: 'Switch to Dark Mode',

  nav_stories: 'Ø§Ù„Ù‚ØµØµ',
  nav_create: 'Ø¥Ù†Ø´Ø§Ø¡',
  nav_login: 'ØªØ³Ø¬ÙŠÙ„ Ø§Ù„Ø¯Ø®ÙˆÙ„',

  page_title_main: 'Story Craft - Ø§Ù„ØµÙØ­Ø© Ø§Ù„Ø±Ø¦ÙŠØ³ÙŠØ©',
  section_browse_by_category: 'ØªØµÙØ­ Ø­Ø³Ø¨ Ø§Ù„ÙØ¦Ø©',
  section_explore_new_games: 'Ø§Ø³ØªÙƒØ´Ù Ø£Ù„Ø¹Ø§Ø¨ Ø¬Ø¯ÙŠØ¯Ø©',
  section_popular: 'Ø´Ø§Ø¦Ø¹',
  section_trending: 'Ø±Ø§Ø¦Ø¬',
  section_trending_now: 'رائج الآن',
  section_popular_picks: 'الأكثر شعبية',
  section_recent_stories: 'Ø§Ù„Ù‚ØµØµ Ø§Ù„Ø£Ø®ÙŠØ±Ø©',
  section_new_stories: 'Ù‚ØµØµ Ø¬Ø¯ÙŠØ¯Ø©',
  btn_load_more_games: 'ØªØ­Ù…ÙŠÙ„ Ø§Ù„Ù…Ø²ÙŠØ¯ ({count} Ø¥Ø¶Ø§ÙÙŠØ©)',
  text_showing_games: 'Ø¹Ø±Ø¶ {visible} Ù…Ù† {total} Ù„Ø¹Ø¨Ø©',
  text_no_category_games: 'Ù„Ù… ÙŠØªÙ… Ø§Ù„Ø¹Ø«ÙˆØ± Ø¹Ù„Ù‰ Ø£Ù„Ø¹Ø§Ø¨ {category}.',
  text_category_games: 'Ø£Ù„Ø¹Ø§Ø¨ {category}',
  text_error_loading_games: 'Ø®Ø·Ø£ ÙÙŠ ØªØ­Ù…ÙŠÙ„ Ø§Ù„Ø£Ù„Ø¹Ø§Ø¨: {error}',

  tell_us_tagline: 'Story Craft: Ø­ÙŠØ« ØªØµØ¨Ø­ Ù‚ØµØµ Ø§Ù„Ù…Ø¹Ø¬Ø¨ÙŠÙ† Ù‚ØµØµØ§Ù‹ Ù‚Ø§Ø¨Ù„Ø© Ù„Ù„Ø¹Ø¨.',
  tell_us_subtitle: 'Ø§Ø¨Ø¯Ø£ Ù„Ø¹Ø¨ØªÙƒ Ø§Ù„ÙŠÙˆÙ…!',
  btn_create_now: 'Ø£Ù†Ø´Ø¦ Ø§Ù„Ø¢Ù†',

  section_comments: 'Ø§Ù„ØªØ¹Ù„ÙŠÙ‚Ø§Øª ({count})',
  text_no_comments: 'Ù„Ø§ ØªÙˆØ¬Ø¯ ØªØ¹Ù„ÙŠÙ‚Ø§Øª Ø¨Ø¹Ø¯. ÙƒÙ† Ø£ÙˆÙ„ Ù…Ù† ÙŠØ´Ø§Ø±Ùƒ Ø£ÙÙƒØ§Ø±Ù‡!',
  btn_load_more_comments: 'ØªØ­Ù…ÙŠÙ„ Ø§Ù„Ù…Ø²ÙŠØ¯ Ù…Ù† Ø§Ù„ØªØ¹Ù„ÙŠÙ‚Ø§Øª',
  text_posting_comment: 'Ø¬Ø§Ø±ÙŠ Ù†Ø´Ø± Ø§Ù„ØªØ¹Ù„ÙŠÙ‚...',
  text_failed_load_comments: 'ÙØ´Ù„ ÙÙŠ ØªØ­Ù…ÙŠÙ„ Ø§Ù„ØªØ¹Ù„ÙŠÙ‚Ø§Øª',
  text_login_to_view_comments: 'Login to view comments',

  page_title_game_not_found: 'Ø§Ù„Ù„Ø¹Ø¨Ø© ØºÙŠØ± Ù…ÙˆØ¬ÙˆØ¯Ø© - Story Craft',
  page_title_game_info: 'Ù…Ø¹Ù„ÙˆÙ…Ø§Øª Ø§Ù„Ù„Ø¹Ø¨Ø© - Story Craft',
  btn_play_now: 'Ø§Ù„Ø¹Ø¨ Ø§Ù„Ø¢Ù†',
  btn_rate: 'Ù‚ÙŠÙ‘Ù…',
  section_about: 'Ø­ÙˆÙ„',
  section_tags: 'Ø§Ù„ÙˆØ³ÙˆÙ…',
  text_views: '{count} Ù…Ø´Ø§Ù‡Ø¯Ø©',
  text_your_rating: 'ØªÙ‚ÙŠÙŠÙ…Ùƒ: {rating} - {title}',
  text_game_id: 'Ù…Ø¹Ø±Ù‘Ù Ø§Ù„Ù„Ø¹Ø¨Ø©: {id}',
  text_no_description: 'Ù‡Ø°Ù‡ Ø§Ù„Ù„Ø¹Ø¨Ø© Ù„ÙŠØ³ Ù„Ù‡Ø§ ÙˆØµÙ.',
  text_game_not_found: 'Ø§Ù„Ù„Ø¹Ø¨Ø© ØºÙŠØ± Ù…ÙˆØ¬ÙˆØ¯Ø©',
  text_failed_load_game: 'ÙØ´Ù„ ÙÙŠ ØªØ­Ù…ÙŠÙ„ Ù…Ø¹Ù„ÙˆÙ…Ø§Øª Ø§Ù„Ù„Ø¹Ø¨Ø©',

  section_similar_games: 'Ø£Ù„Ø¹Ø§Ø¨ Ù…Ø´Ø§Ø¨Ù‡Ø©',
  text_failed_load_similar: 'ÙØ´Ù„ ÙÙŠ ØªØ­Ù…ÙŠÙ„ Ø§Ù„Ø£Ù„Ø¹Ø§Ø¨ Ø§Ù„Ù…Ø´Ø§Ø¨Ù‡Ø©',

  prefooter_btn_start: 'ðŸš€ Start for free',
  prefooter_btn_learn: 'Learn more â†’',

  hero_eyebrow: 'âœ¨ The #1 Interactive Story Creation Platform',
  hero_title: 'Zingplay Story Craft - Tell Your Story',
  hero_subtitle: 'Explore thousands of exciting stories from the creative community. Write, read, and share stories that touch hearts.',
  hero_btn_create: 'ðŸš€ Start Creating',
  hero_btn_explore: 'ðŸ“– Explore Stories',
  hero_stat_stories: '12,000+ Stories',
  hero_stat_authors: '5,000+ Authors',
  hero_stat_rating: '4.9 Rating',

  prefooter_title: 'Ready to tell your story?',
  prefooter_subtitle: 'Join 5,000+ authors creating every day on StoryCraft',
  footer_tagline: 'The #1 Interactive Story Creation Platform',

  footer_terms: 'Terms',
  footer_report: 'Report',
  footer_contact: 'Contact',

  section_story_craft_comments: 'ØªØ¹Ù„ÙŠÙ‚Ø§Øª Story Craft - Ø§Ø³Ø£Ù„ ÙˆØ£Ø¬Ø¨ Ù‡Ù†Ø§',

  section_featured: 'Ù…Ù…ÙŠØ²Ø§Øª Story Craft',
  section_top_genre: 'Ø£ÙØ¶Ù„ Ù‚ØµØµ {genre}',

  translate_popup_eyebrow: 'AI TRANSLATION',
  translate_popup_title: 'Translate story to {targetLang}?',
  translate_popup_message: 'This story is in {originLang}. Do you want to open it with the {targetLang} translation?',
  translate_popup_note: 'Translations are AI-generated and may not be perfect.',
  translate_popup_btn_translate: 'Translate now',
  translate_popup_btn_keep: 'Keep original',
  translate_progress_title: 'Translating storyâ€¦',
  translate_progress_subtitle: 'AI is translating to {targetLang}',
  translate_progress_step_analyze: 'Analyzing contentâ€¦',
  translate_progress_step_generate: 'Generating translationsâ€¦',
  translate_progress_step_pack: 'Updating language packâ€¦',
  translate_progress_step_done: 'All done!',
  translate_progress_flavor_1: 'Reading dialogueâ€¦',
  translate_progress_flavor_2: 'Translating character linesâ€¦',
  translate_progress_flavor_3: 'Converting choicesâ€¦',
  translate_progress_flavor_4: 'Syncing tone of voiceâ€¦',
  translate_progress_flavor_5: 'Proofreadingâ€¦',
  translate_error_title: 'Translation failed',
  translate_error_message: 'Could not translate story: {error}. The story will open in its original language.',
  translate_error_btn_ok: 'Got it',
  event_vote_section_title: 'Participating in Events',
  event_vote_btn: 'Vote',
  event_voted_btn: 'Voted',
  event_vote_count: '{count} votes',

  section_events: 'Events',
  btn_event_detail: 'Details',
  event_ranking_title: 'Story Rankings',
  event_winners_title: 'Winners',
  event_winners_subtitle: 'Top stories that won badges from this event.',
  event_time_label: 'Event Period',
  event_status_not_started: 'Starts in {days} days',
  event_status_starting_soon: 'Starts in {time}',
  event_status_ended: 'Ended',
  event_status_ongoing: '{days} days left',
  event_status_ending_soon: '{time} left',
  event_today_label: 'Today',
  event_day_elapsed: 'Day {day}',
  event_total_days: '{days} days',
  event_votes_label: 'votes',
  event_not_found: 'Event not found or has ended',
  event_not_found_sub: 'Go back to the home page to see ongoing events.',
  event_empty_stories: 'No stories have joined this event yet',
  event_empty_stories_sub: 'Be the first to publish a story and join!',
  event_modal_title: 'Join Event',
  event_modal_no_events: 'No events currently open.',
  event_modal_joined_badge: 'Joined',
  event_modal_go_to_event: 'View event',
  event_modal_join_btn: 'Join',
  event_modal_confirm_title: 'Confirm join',
  event_modal_confirm_body: 'Are you sure you want to join "{name}"? This cannot be undone.',
  event_modal_confirm_btn: 'Confirm join',
  profile_my_profile: 'My Profile',
  profile_tab_badges: 'Badges',
  profile_tab_stories: 'Stories',
  profile_tab_discussion: 'Discussion',
  profile_tab_notifications: 'Notifications',
  profile_notif_empty: 'No notifications yet.',
  profile_notif_game_approved: 'Your story has been approved.',
  profile_notif_game_rejected: 'Your story update was rejected.',
  profile_notif_new_badge: 'You earned a new badge!',
  profile_coming_soon_title: 'Coming Soon',
  profile_coming_soon_sub: 'The Badge system is being developed. Your achievements and titles will appear here.',
  profile_my_stories: 'My Stories',
  profile_stories_guest: 'Stories',
  profile_btn_new_story: 'New Story',
  profile_btn_manage: 'Manage',
  profile_btn_event: 'Event',
  profile_stat_stories: 'Stories',
  profile_stat_views: 'Total Views',
  profile_stat_star: 'Top Star',
  profile_btn_follow: 'Follow',
  profile_btn_message: 'Message',
  profile_discussion_placeholder: 'Leave a message for the author...',
  profile_discussion_login: 'Log in to comment',
  profile_btn_send: 'Send',
  profile_btn_reply: 'Reply',
  profile_btn_hide_comment: 'Hide',
  profile_btn_show_comment: 'Show',
  profile_no_comments: 'No comments yet. Be the first!',
  profile_load_more: 'Load more',
  profile_edit_title: 'Edit Profile',
  profile_edit_change_avatar: 'Change Avatar',
  profile_upload_avatar_error: 'Failed to upload avatar. Please try again.',
  profile_edit_fullname: 'Full Name',
  profile_edit_bio: 'Bio',
  profile_edit_save: 'Save',
  profile_shelf_empty: 'Your story shelf is empty',
  profile_shelf_empty_sub: 'Spin up your first interactive story in StoryCraft Studio. It only takes a few minutes to publish a draft.',
  profile_btn_create_first: 'Create your first story',
  profile_btn_load_more_stories: 'Load more stories',
  profile_save_error: 'Failed to save profile. Please try again.',
  profile_hide_error: 'Failed to hide comment.',
  profile_comment_error: 'Failed to post comment. Please try again.',
  profile_reply_error: 'Failed to post reply. Please try again.',
  profile_btn_cancel: 'Cancel',
  profile_btn_logout: 'Sign out',
  profile_logout_confirm_title: 'Sign out?',
  profile_logout_confirm_body: 'Are you sure you want to sign out of this account? You will be returned to the home page.',
  profile_login_required_title: 'Sign in required',
  profile_login_required_body: 'Sign in to view your profile, your stories and earned badges.',

  rating_warn_title: 'Rated {rating}',
  rating_warn_teen_body: 'This story is rated T (Teen 13+). It may contain mild violence, suggestive themes, or content not suitable for younger readers.',
  rating_warn_mature_body: 'This story is rated M (Mature 18+). It may contain strong violence, adult themes, or other content intended for mature audiences only.',
  rating_warn_continue: 'Continue',
  rating_warn_go_back: 'Go Back',
  rating_warn_confirm_teen: 'I confirm I am 13 years or older.',
  rating_warn_confirm_mature: 'I confirm I am 18 years or older.',

  rating_section_title: 'Content Rating',
  rating_label_e: 'Everyone',
  rating_label_t: 'Teen 13+',
  rating_label_m: 'Mature 18+',
  rating_desc_e: 'Suitable for readers of all ages. Contains content appropriate for everyone.',

  hero_dialog_1: 'Harry Potter accidentally cast the wrong spell on your story again.',
  hero_dialog_2: 'Sherazade is still telling Mina one last story before sunrise…',
  hero_dialog_3: 'Sherlock Holmes noticed a missing plot hole and refused to continue loading.',
  hero_dialog_4: 'Dracula is waiting for permission to enter chapter 2.',
  hero_dialog_5: 'Frodo somehow dropped your save file into Mount Doom.',
  hero_dialog_6: 'Harry Potter and Mina are arguing over who caused the timeline collapse.',
  hero_dialog_7: 'Cinderella missed midnight again, so the loading screen got extended.',
  hero_dialog_8: 'Romeo and Juliet reached your bad ending a little too early.',
  hero_dialog_9: 'Alice opened the wrong rabbit hole and entered your draft folder.',
  hero_dialog_10: 'Mina promised not to read forbidden books anymore. Mina lied.',
  hero_dialog_11: 'Merlin is currently patching a magical bug in the story engine.',
  hero_dialog_12: 'Odysseus has been trying to reach the next chapter for 10 years.',
  hero_dialog_13: 'Dr. Frankenstein touched the codebase. Nobody feels safe anymore.',
  hero_dialog_14: 'Peter Pan refuses to let this story grow up.',
  hero_dialog_15: 'The Little Prince asked Mina why adults write so many tragic endings.',
};
export default ar;
